import { addDays, getTime, isSameDay, startOfDay } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

export const checkIfOneDayEvent = ({ startsAt, endsAt, timeZone }: any) => {
  const zonedStartDate = utcToZonedTime(startsAt, timeZone);
  const zonedEndDate = utcToZonedTime(endsAt, timeZone);

  const isSameDayEvent = isSameDay(zonedStartDate, zonedEndDate);

  const nextDay = addDays(zonedStartDate, 1); // Add one day to the current date
  const isNextDay = isSameDay(nextDay, zonedEndDate);

  const eventEndTime = getTime(zonedEndDate);
  const startOfDayTime = getTime(startOfDay(zonedEndDate));

  const isEventEndsNextDayStarting =
    isNextDay && eventEndTime === startOfDayTime; // Event ending at 12:00 AM is not considered as multi-day event

  return isSameDayEvent || isEventEndsNextDayStarting;
};
